// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconSearch = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M22.282 21.222l-5.75-5.75c2.06-2.46 2.72-5.96 1.38-9.11-1.9-4.47-7.08-6.56-11.55-4.66-4.47 1.9-6.56 7.08-4.66 11.55 1.42 3.35 4.69 5.36 8.12 5.36 1.15 0 2.31-.23 3.43-.7a8.85 8.85 0 002.23-1.37l5.74 5.74c.15.15.34.22.53.22s.38-.07.53-.22c.3-.3.3-.77 0-1.06zm-9.61-4.69c-3.71 1.58-8.01-.16-9.58-3.87-1.58-3.71.16-8.01 3.87-9.58a7.314 7.314 0 019.58 3.87c1.57 3.7-.16 8-3.87 9.58z"
      fill="currentColor"
    />
  );
export default SvgIconSearch;
